export const ContactSubTitle = ({ children }: { children: React.ReactNode }) => {
    return <span className="fs-5 fw-light text-wrap text-break">{children}</span>;
};
